import { DEEP_DAO_API } from './apis';
import { DEEP_DAO_MAIL } from './deepDaoLinks';

import { IDetailedPlansPricings, ISelectOptions, IPremiumPlanDetails, ISubscriptionFaq } from 'types/interfaces';

export enum PLANS_PAGES_INDEXES {
    PLANS_INFO = 1,
    ACCOUNT_INFO = 2,
    PAYMENT = 3,
}

export enum PLANS_DURATIONS {
    MONTHLY_PLAN_DURATION = 'MONTHLY',
    QUARTERLY_PLAN_DURATION = 'QUARTERLY',
    // YEARLY_PLAN_DURATION = 'ANNUALLY',
}

export enum BACKEND_PLAN_NAMES {
    STARTER = 'ECOSYSTEM',
    PRO = 'DAO_ANALYTICS',
}

export enum PLAN_NAMES {
    STARTER = 'Governance',
    PRO = 'Treasury Time Series',
    MARKETING = 'MARKETING',
    CUSTOM = 'CUSTOM',
    BASIC = 'BASIC',
}

export enum PLANS_PRICINGS {
    STARTER_MONTHLY = 1250,
    STARTER_QUARTERLY = 2050,
    // STARTER_YEARLY = 3950,
    PRO_MONTHLY = 850,
    PRO_QUARTERLY = 850,
    // PRO_YEARLY = 3950,
    CUSTOM = 3000,
}

export enum PLAN_ACTIONS {
    CREATING = 'CREATING',
    UPDATING = 'UPDATING',
}

export enum PAYMENT_PROVIDERS {
    PAYPAL = 'paypal',
}

export enum PAYMENT_STATUSES {
    ACTIVE = 'ACTIVE',
    CANCELED = 'CANCELLED',
}

export const detailedPlansPricings: IDetailedPlansPricings = {
    [PLAN_NAMES.STARTER]: [
        {
            id: 1,
            pricing: PLANS_PRICINGS.STARTER_MONTHLY,
            duration: PLANS_DURATIONS.MONTHLY_PLAN_DURATION,
        },
        {
            id: 2,
            pricing: PLANS_PRICINGS.STARTER_QUARTERLY,
            duration: PLANS_DURATIONS.QUARTERLY_PLAN_DURATION,
        },
    ],
    [PLAN_NAMES.PRO]: [
        {
            id: 1,
            pricing: PLANS_PRICINGS.PRO_MONTHLY,
            duration: PLANS_DURATIONS.MONTHLY_PLAN_DURATION,
        },
        {
            id: 2,
            pricing: PLANS_PRICINGS.PRO_QUARTERLY,
            duration: PLANS_DURATIONS.QUARTERLY_PLAN_DURATION,
        },
    ],
};

export enum PAYMENT_METHODS {
    CREDIT_CARD = 'CREDIT_CARD',
    PAYPAL = 'PAYPAL',
}

export const plansDurations: ISelectOptions[] = [
    {
        id: 1,
        name: 'Monthly',
        value: PLANS_DURATIONS.MONTHLY_PLAN_DURATION,
    },
    {
        id: 2,
        name: '3 Months',
        value: PLANS_DURATIONS.QUARTERLY_PLAN_DURATION,
    },
];

export const paymentMethods: ISelectOptions[] = [
    {
        id: 1,
        name: 'paypal',
        value: PAYMENT_METHODS.PAYPAL,
    },
    {
        id: 2,
        name: 'credit card',
        value: PAYMENT_METHODS.CREDIT_CARD,
    },
];

export const plansDetailsList: IPremiumPlanDetails[] = [
    {
        id: 1,
        title: PLAN_NAMES.STARTER,
        planName: PLAN_NAMES.STARTER,
        monthlyPrice: PLANS_PRICINGS.STARTER_MONTHLY,
        quarterlyPrice: PLANS_PRICINGS.STARTER_QUARTERLY,
        allowButton: true,
        emptyPricing: false,
        documentation: {
            link: DEEP_DAO_API,
            title: 'api.deepdao.io',
        },
        planInfo: [
            {
                id: 1,
                text: 'All proposals, votes, voters, for the Top 100 DAOs — $1250',
            },
            {
                id: 2,
                text: 'Delegates for the top 100 DAOs - Add $250',
            },
            {
                id: 3,
                text: 'All proposals, votes, voters, for the Top 300 DAOs — $1450',
            },
            {
                id: 4,
                text: 'Delegates for the top 300 DAOs - Add $350',
            },
            {
                id: 5,
                text: 'Across the Governor and Snapshot platforms',
            },
            {
                id: 6,
                text: 'Start date: since the DAO governance became active',
            },
            {
                id: 7,
                text: 'End date: 2025-11-25',
            },
        ],
    },
    {
        id: 2,
        title: PLAN_NAMES.PRO,
        planName: PLAN_NAMES.PRO,
        allowButton: true,
        disableButton: true,
        emptyPricing: false,
        monthlyPrice: PLANS_PRICINGS.PRO_MONTHLY,
        quarterlyPrice: PLANS_PRICINGS.PRO_QUARTERLY,
        documentation: {
            link: DEEP_DAO_API,
            title: 'api.deepdao.io',
        },
        planInfo: [
            {
                id: 1,
                text: 'Treasury AUM for the top 300 DAOs',
            },
            {
                id: 2,
                text: 'Start date: since the DAO treasury became active on DeepDAO',
            },
            {
                id: 3,
                text: 'End date: 2025-11-25',
            },
        ],
    },
    {
        id: 3,
        title: 'Custom Data',
        planName: 'Marketing',
        emptyPricing: true,
        showContactLinkInDescription: true,
        planInfo: [
            {
                id: 1,
                text: 'Need more data? Contact us for all your DAO data needs. We welcome academics, researchers, and institutions. ',
            }
        ],
    },
];

export const subscriptionFaqList: ISubscriptionFaq[] = [
    {
        id: 1,
        title: 'The most complete aggregation of DAO data and',
    },
    {
        id: 2,
        title: 'Get a step ahead of your DAO competition',
    },
    {
        id: 3,
        title: 'Trends and insights for navigating the DAO ecosystem.',
    },
    {
        id: 4,
        title: 'For custom data contact us at ',
        linkItems: {
            link: DEEP_DAO_MAIL,
            linkText: 'info@deepdao.io',
        },
    },
];
